// extracted by mini-css-extract-plugin
export default {"recipeView":"RecipeView_recipeView__tR6aG"};